import React from 'react';
import dayjs from 'dayjs';

import { Box, Grid } from '@mui/material';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';

import { Button, TextField } from 'shared';
import { filtersStyles } from '../style/style';

const UnimportedTransactionsFilters = ({
    values,
    handleReset,
    handleChange,
    setFieldValue,
    handleClearClick,
}) => {
    const classes = filtersStyles();

    return (
        <Box padding="0 20px">
            <Grid container spacing={2} marginTop="5px">
                <Grid item xs={12} md={3} lg={3}>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DatePicker
                            value={values.date && dayjs(values.date)}
                            onChange={(date) => setFieldValue('date', date)}
                            label="Select Date"
                            placeholder="Select Date"
                            format="MM-DD-YYYY"
                            sx={classes.datePicker}
                        />
                    </LocalizationProvider>
                </Grid>
                <Grid item xs={12} md={6} lg={3}>
                    <TextField
                        fullWidth
                        name="description"
                        value={values.description}
                        placeholder="Search by description"
                        onChange={handleChange}
                        customStyle={classes.inputField}
                    />
                </Grid>
            </Grid>

            <Grid container spacing={2}>
                <Grid item xs={24} marginTop="10px" marginBottom="10px">
                    <Button
                        text="Clear"
                        onClick={() => handleClearClick(handleReset)}
                        customStyles={classes.clearButton}
                    />
                    <Button text="Apply" type="submit" />
                </Grid>
            </Grid>
        </Box>
    );
};

export default UnimportedTransactionsFilters;
